import { Module, VuexModule, Mutation, MutationAction, getModule, Action } from 'vuex-module-decorators';
import store from '@/store';
import { IDexieDataSetEvent, DexieDataSetEvent } from '@/models/dexie/UnsyncedDexieDataSet';
import { EventsService } from '@/services/index';
import { LoggerService } from '@/utils';


export interface IEventStoreState {
    unsyncedEvents: IDexieDataSetEvent[];
}

@Module({ dynamic: true, store, name: 'eventStore' })
class EventStoreModule extends VuexModule implements IEventStoreState {
    public unsyncedEvents: DexieDataSetEvent[] = [];
    public test: boolean = false;


    /**
     * Set new unsynced events array
     * @param inUnsyncedEvents The new unsynced events
     */
    @MutationAction({ mutate: ['unsyncedEvents'] })
    public async SetUnsyncedEvents(inUnsyncedEvents?: DexieDataSetEvent[]) {
        if (inUnsyncedEvents === undefined) {
            await EventsService.GetAllUnsyncedEvents()
                .then((data) => {
                    inUnsyncedEvents = data;
                })
                .catch((error) => {
                    LoggerService.LogError(`Error on SetUnsyncedEvents: `, error);
                });
        } else {
            // first clear old events from index db
            await EventsService.DeleteAllUnsyncedEvents()
            .catch((error) => {
                LoggerService.LogError(`Error on deleteing old unsynced events: `, error);
            });
            // second save new list of unsynced events
            await EventsService.PutUnsyncedEvents(inUnsyncedEvents)
            .catch((error) => {
                LoggerService.LogError(`Error on bulk saving new unsynced events: `, error);
            });
        }

        return { unsyncedEvents: inUnsyncedEvents };
    }

    /**
     * Clear the whole unsynced events
     */
    @Mutation
    public async ClearUnsyncedEvents() {
        this.unsyncedEvents.splice(0, this.unsyncedEvents.length);
    }

    /**
     * Getter for unsynced events
     */
    get GetUnsyncedEvents(): DexieDataSetEvent[] {
        return this.unsyncedEvents;
    }
}

export const EventStore = getModule(EventStoreModule);
